/**
 * 全局通话状态管理器
 *  0-默认初始状态 | 结束
 *  1- 呼叫中
 *  2- 通话中
 */

export default {
  state: {
    callStatus: 0,
  },
  mutations: {
    setTelCallState (state, callStatus) {
      state.callStatus = callStatus;
    }
  },
  getters: {
    callStatus: state => state.callStatus
  },
  namespaced: true
};